module.exports = __webpack_public_path__ + "img/bpOrange.03d6c3e6.png";